import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { ChapterFormValues } from "src/models/Chapter.model";
import ChapterForm from "../Layouts/ChapterForm";
import { useAddChapterMutation } from "src/services/ChapterServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
  moduleId?: string ; 
};

const AddChapterFormWrapper = ({ onClose , moduleId }: Props) => {
  const [addChapter] = useAddChapterMutation();
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  // Form Initial Values
  const initialValues: ChapterFormValues = {
    chapterName: "",
    chapterContent: "",
    duration: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    chapterName: string().required("Please enter chapter name"),
    chapterContent: string().required("Please enter chapter content"),
    duration: string().required("Please enter duration"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ChapterFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ChapterFormValues>
  ) => {
  
    const formattedValues ={
      chapterName : values?.chapterName ,
      chapterContent : values?.chapterContent ,
      duration : values?.duration ,
      moduleId : moduleId ? moduleId: null ,
    }

    addChapter(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
   <div className="zindex">
     <Dialog open maxWidth='lg' fullWidth >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ChapterForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
   </div>
  );
};

export default AddChapterFormWrapper;
